var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSloganKaiperClearspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 758.67 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .slogan_kaiper_clearspace-1 {\n        clip-path: url(#slogan_kaiper_default_clippath-4);\n      }\n\n      .slogan_kaiper_clearspace-2, .slogan_kaiper_clearspace-3 {\n        fill: none;\n      }\n\n      .slogan_kaiper_clearspace-4 {\n        clip-path: url(#slogan_kaiper_default_clippath-1);\n      }\n\n      .slogan_kaiper_clearspace-3 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .slogan_kaiper_clearspace-5 {\n        clip-path: url(#slogan_kaiper_default_clippath-3);\n      }\n\n      .slogan_kaiper_clearspace-6 {\n        clip-path: url(#slogan_kaiper_default_clippath-2);\n      }\n\n      .slogan_kaiper_clearspace-7 {\n        opacity: .2;\n      }\n\n      .slogan_kaiper_clearspace-8 {\n        opacity: .05;\n      }\n\n      .slogan_kaiper_clearspace-9 {\n        clip-path: url(#slogan_kaiper_default_clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "slogan_kaiper_default_clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-2",
    x: 693.33,
    y: 7.69,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "slogan_kaiper_default_clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-2",
    x: 65.51,
    y: 46,
    width: 627.82,
    height: 52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "slogan_kaiper_default_clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-2",
    x: 25.51,
    y: 7.69,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "slogan_kaiper_default_clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-2",
    x: 25.51,
    y: 87.69,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "slogan_kaiper_default_clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-2",
    x: 693.33,
    y: 87.69,
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 693.33,
    y: 7.69,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-3",
    x: 693.33,
    y: 7.69,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.51,87.69v-40h16.34c7.89,0,13.01,3.21,13.01,10.25v.62c0,3.44-1.8,6.48-5.13,8,4.34,1.35,6.93,4.96,6.93,9.3v.68c0,7.1-5.69,11.15-13.58,11.15h-17.58ZM71.93,64.59h9.58c4.68,0,6.76-2.03,6.76-5.52v-.62c0-3.89-2.42-5.35-6.93-5.35h-9.41v11.49ZM71.93,82.28h10.65c4.51,0,7.44-1.97,7.44-5.86v-.73c0-3.72-2.48-5.69-7.15-5.69h-10.93v12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.05,87.69v-29.01h5.97l.17,5.63c1.58-3.72,4.62-6.2,8.79-6.2.45,0,1.07.06,1.58.17v6.03c-.56-.06-1.24-.11-1.91-.11-5.24,0-8.4,2.99-8.4,8.73v14.76h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,73.61v-.85c0-8.79,5.46-14.76,14.37-14.76,9.52,0,14.14,6.65,13.69,16.56h-21.69c.28,5.8,3.1,8.9,8,8.9,4.06,0,6.48-1.92,7.32-4.85h6.2c-1.41,6.08-6.25,9.8-13.52,9.8-9.01,0-14.37-6.03-14.37-14.82M140.38,70.11c-.45-4.51-2.82-7.21-7.38-7.21s-7.16,2.48-7.83,7.21h15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,79.86c0-4.62,2.82-7.66,7.77-8.34l11.44-1.69v-2.08c0-3.21-2.2-4.9-5.86-4.9s-6.03,1.63-6.31,4.56h-5.92c.51-5.97,5.24-9.41,12.34-9.41,7.49,0,11.72,3.94,11.72,9.97v19.72h-5.69l-.23-4.51c-1.8,3.27-5.35,5.24-9.52,5.24-5.97,0-9.75-3.61-9.75-8.56M168.71,77.04v-2.65l-9.3,1.3c-2.65.39-3.89,1.63-3.89,3.89,0,2.42,1.86,3.94,5.13,3.94,4.34,0,8.06-2.7,8.06-6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.34 76.99 186.34 87.69 180.14 87.69 180.14 46 186.34 46 186.34 70.28 197.72 58.68 205.21 58.68 193.67 70.28 205.61 87.69 198.51 87.69 189.21 74.11 186.34 76.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.7,54.45h-6.48v-8.45h6.48v8.45ZM224.53,87.69h-6.2v-29.01h6.2v29.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.45,87.69v-29.01h5.97l.22,4.62c1.52-2.87,4.56-5.3,9.24-5.3,7.04,0,10.03,4.39,10.03,10.99v18.7h-6.14v-17.18c0-4.73-1.75-7.38-5.97-7.38s-7.16,3.15-7.16,8.34v16.22h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.63,79.86v-16.51h-5.63v-4.68h5.63v-9.07h6.2v9.07h7.89v4.68h-7.89v15.83c0,2.87,1.07,4.17,4.51,4.17,1.24,0,2.7-.28,3.55-.56v4.96c-1.3.39-3.27.68-4.73.68-6.37,0-9.52-2.93-9.52-8.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.46,73.61v-.84c0-8.85,5.63-14.76,14.31-14.76s14.37,5.92,14.37,14.76v.84c0,8.85-5.63,14.82-14.37,14.82s-14.31-5.97-14.31-14.82M301.82,73.61v-.84c0-6.25-2.76-9.75-8.06-9.75s-8,3.49-8,9.75v.84c0,6.25,2.76,9.8,8,9.8s8.06-3.55,8.06-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.38,93.72c3.32,0,4.73-1.41,4.73-4.84v-1.18h-2.93v-6.76h6.7v7.55c0,5.8-2.99,8.67-8.51,8.67v-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84,87.69v-40h16.34c7.89,0,13.01,3.21,13.01,10.25v.62c0,3.44-1.8,6.48-5.13,8,4.34,1.35,6.93,4.96,6.93,9.3v.68c0,7.1-5.69,11.15-13.58,11.15h-17.58ZM342.27,64.59h9.58c4.68,0,6.76-2.03,6.76-5.52v-.62c0-3.89-2.42-5.35-6.93-5.35h-9.41v11.49ZM342.27,82.28h10.65c4.51,0,7.44-1.97,7.44-5.86v-.73c0-3.72-2.48-5.69-7.16-5.69h-10.93v12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.39,87.69v-29.01h5.97l.17,5.63c1.58-3.72,4.62-6.2,8.79-6.2.45,0,1.07.06,1.58.17v6.03c-.56-.06-1.24-.11-1.91-.11-5.24,0-8.4,2.99-8.4,8.73v14.76h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.02,73.61v-.85c0-8.79,5.46-14.76,14.37-14.76,9.52,0,14.14,6.65,13.69,16.56h-21.69c.28,5.8,3.1,8.9,8,8.9,4.06,0,6.48-1.92,7.32-4.85h6.2c-1.41,6.08-6.25,9.8-13.52,9.8-9.01,0-14.37-6.03-14.37-14.82M410.71,70.11c-.45-4.51-2.82-7.21-7.38-7.21s-7.16,2.48-7.83,7.21h15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,79.86c0-4.62,2.82-7.66,7.77-8.34l11.44-1.69v-2.08c0-3.21-2.2-4.9-5.86-4.9s-6.03,1.63-6.31,4.56h-5.92c.51-5.97,5.24-9.41,12.34-9.41,7.49,0,11.72,3.94,11.72,9.97v19.72h-5.69l-.23-4.51c-1.8,3.27-5.35,5.24-9.52,5.24-5.97,0-9.75-3.61-9.75-8.56M439.05,77.04v-2.65l-9.3,1.3c-2.65.39-3.89,1.63-3.89,3.89,0,2.42,1.86,3.94,5.13,3.94,4.34,0,8.06-2.7,8.06-6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.68 76.99 456.68 87.69 450.48 87.69 450.48 46 456.68 46 456.68 70.28 468.06 58.68 475.55 58.68 464 70.28 475.94 87.69 468.85 87.69 459.55 74.11 456.68 76.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.83,79.86v-16.51h-5.63v-4.68h5.63v-9.07h6.2v9.07h7.89v4.68h-7.89v15.83c0,2.87,1.07,4.17,4.51,4.17,1.24,0,2.7-.28,3.55-.56v4.96c-1.3.39-3.27.68-4.73.68-6.37,0-9.52-2.93-9.52-8.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.3,87.69v-41.69h6.25v17.13c1.58-2.87,4.56-5.13,9.18-5.13,7.04,0,10.03,4.39,10.03,10.99v18.7h-6.14v-17.18c0-4.73-1.75-7.38-5.97-7.38s-7.16,3.15-7.16,8.34v16.22h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.23,87.69v-29.01h5.97l.17,5.63c1.58-3.72,4.62-6.2,8.79-6.2.45,0,1.07.06,1.58.17v6.03c-.56-.06-1.24-.11-1.91-.11-5.24,0-8.4,2.99-8.4,8.73v14.76h-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.58,73.61v-.84c0-8.85,5.63-14.76,14.31-14.76s14.37,5.92,14.37,14.76v.84c0,8.85-5.63,14.82-14.37,14.82s-14.31-5.97-14.31-14.82M580.95,73.61v-.84c0-6.25-2.76-9.75-8.06-9.75s-8,3.49-8,9.75v.84c0,6.25,2.76,9.8,8,9.8s8.06-3.55,8.06-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.31,77.32v-18.65h6.25v17.46c0,4.45,1.63,7.1,5.8,7.1s6.82-3.27,6.82-8.45v-16.11h6.25v29.01h-6.03l-.11-4.39c-1.69,2.82-4.79,5.13-8.96,5.13-6.76,0-10.03-4.28-10.03-11.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.39,89.38h6.76c.34,2.54,2.54,3.94,6.7,3.94,4.79,0,7.66-2.37,7.66-6.93v-4.28c-1.52,2.82-4.79,5.13-9.3,5.13-7.72,0-12.56-6.09-12.56-14.09v-1.13c0-8.06,4.79-14.03,12.39-14.03,4.96,0,8.28,2.7,9.75,5.47l.17-4.79h5.75v27.15c0,7.49-5.01,12.17-14.2,12.17-8,0-12.51-3.55-13.13-8.62M642.74,73.15v-1.13c0-5.63-2.82-9.13-8-9.13s-7.77,3.49-7.77,9.13v1.13c0,5.52,2.82,9.13,7.77,9.13s8-3.61,8-9.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.35,87.69v-41.69h6.25v17.13c1.58-2.87,4.56-5.13,9.18-5.13,7.04,0,10.03,4.39,10.03,10.99v18.7h-6.14v-17.18c0-4.73-1.75-7.38-5.97-7.38s-7.16,3.15-7.16,8.34v16.22h-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.63,
    y: 80.93,
    width: 6.7,
    height: 6.76
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "slogan_kaiper_clearspace-3",
    points: "738.33 87.69 742.63 87.69 742.63 47.69 738.33 47.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "749.59 67.2 749.64 67.2 751.08 64.86 751.91 64.86 750.14 67.69 751.91 70.52 751.08 70.52 749.64 68.23 749.59 68.23 748.14 70.52 747.32 70.52 749.14 67.69 747.32 64.86 748.15 64.86 749.59 67.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.51,
    y: 7.69,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-3",
    x: 25.51,
    y: 7.69,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.49 27.2 45.53 27.2 46.98 24.86 47.81 24.86 46.03 27.69 47.81 30.52 46.98 30.52 45.53 28.23 45.49 28.23 44.04 30.52 43.21 30.52 45.03 27.69 43.21 24.86 44.05 24.86 45.49 27.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.51,
    y: 87.69,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-3",
    x: 25.51,
    y: 87.69,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.49 107.2 45.53 107.2 46.98 104.86 47.81 104.86 46.03 107.69 47.81 110.52 46.98 110.52 45.53 108.23 45.49 108.23 44.04 110.52 43.21 110.52 45.03 107.69 43.21 104.86 44.05 104.86 45.49 107.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.3 27.2 713.35 27.2 714.79 24.86 715.62 24.86 713.85 27.69 715.62 30.52 714.79 30.52 713.35 28.23 713.3 28.23 711.86 30.52 711.03 30.52 712.85 27.69 711.03 24.86 711.86 24.86 713.3 27.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "slogan_kaiper_clearspace-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 693.33,
    y: 87.69,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-3",
    x: 693.33,
    y: 87.69,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.3 107.2 713.35 107.2 714.79 104.86 715.62 104.86 713.85 107.69 715.62 110.52 714.79 110.52 713.35 108.23 713.3 108.23 711.85 110.52 711.03 110.52 712.85 107.69 711.03 104.86 711.86 104.86 713.3 107.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-3",
    x: 65.51,
    y: 47.69,
    width: 627.82,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-3",
    x: 25.51,
    y: 7.69,
    width: 707.82,
    height: 120
  })), /*#__PURE__*/React.createElement("rect", {
    className: "slogan_kaiper_clearspace-2",
    width: 758.67,
    height: 144
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSloganKaiperClearspace);
export default __webpack_public_path__ + "static/media/slogan_kaiper_clearspace.08bd210d427da5fdb21eb2340759a08d.svg";
export { ForwardRef as ReactComponent };